export default __webpack_public_path__ + "static/media/yeezy3.683f685a.jpg";